import { getHelpCategoryIcon } from './helpIcons.js';

let cmsBundle = null;

export function setHelpCmsBundle(bundle) {
  cmsBundle = bundle && Array.isArray(bundle.articles) && bundle.articles.length
    ? bundle
    : null;
}

export function getHelpCmsBundle() {
  return cmsBundle;
}

export function hasHelpCmsBundle() {
  return Boolean(cmsBundle?.articles?.length);
}

function sectionArticles(sectionKey) {
  return (cmsBundle?.articles || []).filter((a) => a.sectionKey === sectionKey);
}

function sectionCategories(sectionKey) {
  return (cmsBundle?.categories || []).filter((c) => c.sectionKey === sectionKey && c.slug !== '_');
}

export function cmsHelpSections() {
  return cmsBundle?.sections || null;
}

export function cmsFaqCategories() {
  return sectionCategories('faq').map((item) => ({
    slug: item.slug,
    title: item.title,
    desc: item.desc || '',
    icon: getHelpCategoryIcon(item.iconKey),
  }));
}

export function cmsFaqQuestions() {
  const map = {};
  for (const art of sectionArticles('faq')) {
    if (!map[art.categoryKey]) map[art.categoryKey] = [];
    map[art.categoryKey].push({
      id: art.id || art.slug,
      slug: art.slug,
      q: art.q || art.title,
      aHtml: art.aHtml || '',
      a: art.a || '',
      views: art.views || 0,
    });
  }
  return map;
}

export function cmsInstructionCategories() {
  return sectionCategories('instructions').map((item) => ({
    slug: item.slug,
    title: item.title,
    desc: item.desc || '',
    icon: getHelpCategoryIcon(item.iconKey),
  }));
}

export function cmsInstructionArticles(catSlug) {
  return sectionArticles('instructions')
    .filter((a) => a.categoryKey === catSlug)
    .map((a) => ({
      slug: a.slug,
      title: a.title,
      content: a.content?.length ? a.content : [a.a || a.text || ''].filter(Boolean),
    }));
}

export function cmsInstructionArticle(catSlug, articleSlug) {
  const art = sectionArticles('instructions').find(
    (a) => a.categoryKey === catSlug && a.slug === articleSlug,
  );
  if (!art) return null;
  const cat = sectionCategories('instructions').find((c) => c.slug === catSlug);
  return {
    category: cat
      ? { slug: cat.slug, title: cat.title, desc: cat.desc || '' }
      : { slug: catSlug, title: catSlug, desc: '' },
    slug: art.slug,
    title: art.title,
    content: art.content?.length ? art.content : [art.a || art.text || ''].filter(Boolean),
  };
}

export function cmsTrainingCategories() {
  return sectionCategories('training').map((item) => ({
    slug: item.slug,
    title: item.title,
    desc: item.desc || '',
    icon: getHelpCategoryIcon(item.iconKey),
  }));
}

export function cmsTrainingArticles(catSlug) {
  return sectionArticles('training')
    .filter((a) => a.categoryKey === catSlug)
    .map((a) => ({
      slug: a.slug,
      title: a.title,
      content: a.content?.length ? a.content : [a.a || a.text || ''].filter(Boolean),
    }));
}

export function cmsTrainingArticle(catSlug, articleSlug) {
  const art = sectionArticles('training').find(
    (a) => a.categoryKey === catSlug && a.slug === articleSlug,
  );
  if (!art) return null;
  const cat = sectionCategories('training').find((c) => c.slug === catSlug);
  return {
    category: cat
      ? { slug: cat.slug, title: cat.title, desc: cat.desc || '' }
      : { slug: catSlug, title: catSlug, desc: '' },
    slug: art.slug,
    title: art.title,
    content: art.content?.length ? art.content : [art.a || art.text || ''].filter(Boolean),
  };
}

export function cmsGlossaryTerms() {
  return sectionArticles('glossary').map((a) => ({
    slug: a.slug,
    letter: a.letter || (a.title || '').charAt(0).toUpperCase(),
    title: a.title,
    text: a.text || a.a || '',
  }));
}

export function cmsGlossaryTerm(slug) {
  return cmsGlossaryTerms().find((t) => t.slug === slug) || null;
}
